import PropTypes from 'prop-types'
import { RootMixin } from 'legacy/libs/baobab-react-mixins'

import createReactClass from 'create-react-class'

export default createReactClass({
  displayName: 'Wrapper',

  mixins: [RootMixin],

  childContextTypes: {
    onResolve: PropTypes.func,
  },

  getChildContext() {
    return {
      // eslint-disable-next-line react/prop-types
      onResolve: this.props.onResolve,
    }
  },

  render() {
    // eslint-disable-next-line react/prop-types
    return this.props.children
  },
})
